export default class Lang {
    static get(key, replacements = {}) {
        // Retrieve the current locale
        const locale = document.documentElement.lang

        // Always include the locale
        if (!key.startsWith(locale)) {
            key = locale + '.' + key
        }

        // Properly handle the nested keys
        let translation = key.split('.').reduce((t, i) => (t && t[i]) ?? null, window.translations)

        // When the translation can't be found, return the key
        if (!translation) {
            console.warn('Missing translation for `' + key + '`')
            return key
        }

        // When the translation is an object, do not use replacements
        // prettier-ignore
        if (typeof translation !== 'string' && !(translation instanceof String)) {
            return ''
        }

        // Handle replacements in the translation
        for (let placeholder in replacements) {
            translation = translation.replace(':' + placeholder, replacements[placeholder])
        }

        return translation
    }
}
